import { createElement, memo, useEffect } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import TopView from '@max/leez-top-view';
import Image from "@max/leez-image";
import ModalBaseContainer from '@max/leez-modal-base-container';
import { AmountType, BizLineDesc } from '../../types';
import './index.scss';
import { getFullScreenSize } from "@/utils/layout";
import { convertCentsToYuan2, MTNewDigitalDisplayStyle } from '@/utils/common';
import { BID_MAP, BID_TYPE } from '../../constants';
import { getSystemType, SystemType } from '@nibfe/mkt-env-api';
const CommonPrizeModal = ({ visible, prize, onClose, onGoToUse, lxReport }) => {
    const { fullScreenHeight } = getFullScreenSize();
    const systemType = getSystemType();
    const isIOS = systemType === SystemType.ios;
    useEffect(() => {
        if (visible) {
            // 弹窗曝光上报
            lxReport === null || lxReport === void 0 ? void 0 : lxReport(BID_MAP.COMMON_MODAL_MV, BID_TYPE.MV);
        }
    }, [visible, lxReport]);
    if (!visible || !prize) {
        return null;
    }
    let finalAmount = prize.amount;
    if (prize.amountType === AmountType.FullReduction) {
        const res = convertCentsToYuan2(Number(prize.amount));
        finalAmount = res.integerPart;
    }
    if (prize.amountType === AmountType.Discount) {
        const discountValue = Number(prize.amount) / 10;
        // 判断是否为整数，如果是整数则不显示小数位，否则显示1位小数
        finalAmount = Number.isInteger(discountValue) ? discountValue.toString() : discountValue.toFixed(1);
    }
    const handleGoToUse = () => {
        onGoToUse && onGoToUse(prize);
    };
    let prizeTypeDesc = BizLineDesc[prize.bizLine];
    if (!prizeTypeDesc) {
        prizeTypeDesc = prize.amountType === AmountType.Discount ? '折扣' : '满减';
    }
    // let requireAmount = Number(prize?.requireAmount) ? `满${Number(prize?.requireAmount)}可用` : '无门槛';
    const requireAmount = (prize === null || prize === void 0 ? void 0 : prize.requireAmount) ? `${(prize === null || prize === void 0 ? void 0 : prize.requireAmount.indexOf('满')) > -1 ? '' : '满'}${prize === null || prize === void 0 ? void 0 : prize.requireAmount}${(prize === null || prize === void 0 ? void 0 : prize.requireAmount.indexOf('可用')) > -1 ? '' : '可用'}` : '无门槛';
    const renderContent = () => {
        return <View className="common-prize-modal-content-wrap">
        <View>
          <Image source={{
            uri: 'https://p0.meituan.net/ingee/2134a482e72ac40e4841d5f802a800ee19654.png'
        }} style={{
            width: '312rpx',
            height: '96rpx',
            marginLeft: '46rpx',
            marginBottom: '52rpx'
        }} borderRadius={0}/>
        </View>
        
        <Image className="common-prize-modal-content" source={{
            uri: 'https://p0.meituan.net/ingee/28a0f1f05ded077b8be74af224a3fede219454.png'
        }} style={{
            width: '685rpx',
            height: '552rpx'
        }} resizeMode='cover' borderRadius={0}>
          

          <View className="common-prize-modal-header">
            <Text className="common-prize-modal-title">
              {prizeTypeDesc}优惠券
            </Text>
          </View>
          <View className="common-prize-modal-card">
            <View className="common-prize-price">
              <Text x-if={prize.amountType === AmountType.FullReduction} className="common-prize-amount-wrap">
                <Text className="common-prize-price-symbol">¥</Text>
                <Text className="common-prize-price-value" style={MTNewDigitalDisplayStyle}>{finalAmount}</Text>
              </Text>
              <Text x-if={prize.amountType === AmountType.Discount} className="common-prize-amount-wrap">
                <Text className="common-prize-price-value" style={MTNewDigitalDisplayStyle}>{finalAmount}</Text>
                <Text className="common-prize-price-symbol">折</Text>
              </Text>
            </View>
            <Text className="common-prize-modal-require" style={{
            marginTop: isIOS ? '-10rpx' : '10rpx',
            marginBottom: isIOS ? '0rpx' : '10rpx'
        }}>{requireAmount}</Text>
            <Text className="common-prize-modal-tip">优惠券已入账【酒旅频道-我的优惠】</Text>
          </View>

          
          <Image className="common-prize-modal-action-btn" source={{
            uri: 'https://p0.meituan.net/ingee/e2557fd9ea694002136ccab8fc0c37d719817.png'
        }} style={{
            width: '450rpx',
            height: '96rpx',
            marginTop: '68rpx',
            marginLeft: '-25rpx'
        }} borderRadius={0} onPress={() => {
            lxReport === null || lxReport === void 0 ? void 0 : lxReport(BID_MAP.COMMON_MODAL_MC, BID_TYPE.MC);
            handleGoToUse();
        }}/>
        </Image>

        
        <Image onPress={onClose} source={{
            uri: 'https://p0.meituan.net/ingee/94047ffc6fa8ede65644e7a2653da1691779.png'
        }} style={{
            width: '48rpx',
            height: '48rpx',
            marginTop: '52rpx'
            // marginLeft: '-30rpx'
        }} className="common-prize-modal-close-btn"/>
      </View>;
    };
    return <TopView>
      <ModalBaseContainer visible={visible} contentStyle={{
        width: '750rpx',
        height: fullScreenHeight,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative'
    }}>
        {renderContent()}
      </ModalBaseContainer>
    </TopView>;
};
export default memo(CommonPrizeModal);
